import { Component } from '@angular/core';

@Component({
  selector: 'greco-schedule-wrapper-page',
  template: `<greco-schedule-page></greco-schedule-page>`,
})
export class ScheduleWrapperPage {}
